<template>
  <footer class="py-2 text-white bg-dark">
    <div class="container text-center">
      <p>Copyright &copy; {{ company }} 2018-{{ getCurrentYear() }}. {{ $t('copyright')}}.</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'smfFooter',
  props: {
    company: String
  },
  methods: {
    getCurrentYear () {
      var dt = new Date()
      return dt.getFullYear()
    }
  }
}
</script>
